import NewsItem from './NewsItem';

export default NewsItem;
